export const homeObjOne ={
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:true,
    topLine:'Web agency',
    headline:'Innovative and at the top of the trend',
    description:'Our Team is working with the latest web and mobile technology. we deliver a fast and an easy to maintain project',
    buttonLabel:'Get Started',
    imgStart:false,
    img:require('../../images/svg-1.svg').default,
    alt:'dev',
    primary:true,
    dark:true,
    darkText:false,

}

export const homeObjTwo ={
    id:'discover',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'Meet our young talented mind',
    headline:'Mixing art and technology',
    description:'For the best user interface and experience',
    buttonLabel:'Learn more',
    imgStart:true,
    img:require('../../images/svg-2.svg').default,
    alt:'art',
    primary:false,
    dark:false,
    darkText:true,

}

export const homeObjThree ={
    id:'signup',
    lightBg:false,
    lightText:true,
    lightTextDesc:true,
    topLine:'Join the mouvement',
    headline:'Create your account in a couples of clicks',
    description:'Easy and fast register. To send us some enquiery over your project',
    buttonLabel:'Sign up',
    imgStart:false,
    img:require('../../images/svg-3.svg').default,
    alt:'signup',
    primary:true,
    dark:true,
    darkText:false,

}